import { render } from "./ReceiptUpdate.vue?vue&type=template&id=ddb6a71a&scoped=true"
import script from "./ReceiptUpdate.vue?vue&type=script&lang=js"
export * from "./ReceiptUpdate.vue?vue&type=script&lang=js"

import "./ReceiptUpdate.vue?vue&type=style&index=0&id=ddb6a71a&scoped=true&lang=css"

import exportComponent from "C:\\frontend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddb6a71a"]])

export default __exports__